export default "__VITE_ASSET__OZ1alrRP__"